import { alpha, Theme } from '@mui/material';

export default function CssBaseline(theme: Theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          fontFamily: theme.typography.fontFamily,
          '&::-webkit-scrollbar': {
            width: theme.spacing(2),
            height: theme.spacing(2),
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: alpha(theme.palette.text.primary, 0.5),
            borderRadius: theme.spacing(1),
          },
        },
        'html, body, #root': {
          height: '100%',
        },
        html: {
          WebkitTapHighlightColor: 'transparent',
          fontSize: theme.typography.textMd.fontSize,
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        '.grecaptcha-badge': { visibility: 'hidden' },

        // NProgress
        '#nprogress .bar': {
          background: theme.palette.primary.main,
          position: 'fixed',
          zIndex: 1031,
          top: 0,
          left: 0,
          width: '100%',
          height: 3,
        },

        // React Toastify
        '.Toastify': {
          fontSize: theme.typography.textMd.fontSize,
        },
        ':root': {
          ' --toastify-color-light': theme.palette.common.white,
          ' --toastify-color-dark': theme.palette.common.black,
          ' --toastify-color-info': theme.palette.info.main,
          ' --toastify-color-success': theme.palette.success.main,
          ' --toastify-color-warning': theme.palette.warning.main,
          ' --toastify-color-error': theme.palette.error.main,

          '--toastify-icon-color-info': theme.palette.info.main,
          '--toastify-icon-color-success': theme.palette.success.main,
          '--toastify-icon-color-warning': theme.palette.warning.main,
          '--toastify-icon-color-error': theme.palette.error.main,
          '--toastify-font-family': theme.typography.fontFamily,
        },

        // Uppy

        '.uppy-Dashboard-Item-name': {
          color: theme.palette.text.primary,
        },
        '.uppy-Dashboard-Item-status': {
          color: theme.palette.text.tertiary,
        },
        '.uppy-DashboardContent-bar, .uppy-ProviderBrowser-header': {
          borderBottomColor: `${theme.palette.divider}!important`,
        },
        '.uppy-StatusBar:not([aria-hidden=true]).is-waiting, .uppy-ProviderBrowser-footer':
          {
            borderTopColor: `${theme.palette.divider}!important`,
            backgroundColor: 'transparent !important',
            color: `${theme.palette.text.primary} !important`,
          },
        '.uppy-c-btn-primary': {
          backgroundColor: `${theme.palette.primary.main} !important`,
          '&:hover': {
            backgroundColor: `${theme.palette.primary[700]} !important`,
          },
          color: theme.palette.common.white,
        },
        '.uppy-StatusBar': {
          backgroundColor: `${theme.palette.background.secondarySubtle} !important`,
          color: `${theme.palette.text.primary} !important`,
          ':before': {
            backgroundColor: `${theme.palette.divider} !important`,
          },
        },
        '.uppy-StatusBar-content': {
          color: `${theme.palette.text.primary} !important`,
        },
        '.uppy-DashboardContent-panel': {
          backgroundColor: `${theme.palette.background.secondary} !important`,
        },
        '.uppy-Provider-authTitle': {
          color: `${theme.palette.text.disabled} !important`,
        },
        '.uppy-ProviderBrowser-headerBar': {
          backgroundColor: `${theme.palette.background.primaryAlt} !important`,
        },
        '.uppy-ProviderBrowser-user, .uppy-Provider-breadcrumbs button:last-of-type':
          {
            color: `${theme.palette.text.secondary} !important`,
          },
        '.uppy-ProviderBrowser-viewType--list, .uppy-ProviderBrowser-list': {
          backgroundColor: `${theme.palette.background.default} !important`,
        },
        '.uppy-ProviderBrowser-searchFilterInput': {
          backgroundColor: `${theme.palette.background.secondary} !important`,
          color: `${theme.palette.text.primary} !important`,
          border: `1px solid ${theme.palette.divider} !important`,
        },
        '.uppy-Root': {
          color: `${theme.palette.text.primary} !important`,
        },
        '.uppy-c-btn-link': {
          color: `${theme.palette.text.quaternary} !important`,
        },
        '.uppy-Provider-breadcrumbs': {
          color: `${theme.palette.text.disabled} !important`,
        },
        '.uppy-DashboardContent-back, .uppy-ProviderBrowser-userLogout': {
          color: `${theme.palette.primary} !important`,
        },
        '.uppy-DashboardContent-back:focus, .uppy-DashboardContent-save:focus':
          {
            backgroundColor: `${theme.palette.background.secondary} !important`,
          },
        '.uppy-ProviderBrowser-viewType--list .uppy-ProviderBrowserItem--is-checked .uppy-ProviderBrowserItem-checkbox':
          {
            backgroundColor: `${theme.palette.primary.main} !important`,
            borderColor: `${theme.palette.primary.dark} !important`,
          },
      },
    },
  };
}
